import * as faker from 'faker';

import { Activity, ItemTypes, ItemActivities, ItemActions } from './activity';

export class MockActivity extends Activity {
   constructor() {
      super({
         id: faker.datatype.number(),
         timestamp: faker.date.recent().toISOString(),
         userFullName: faker.name.findName(),
         name: faker.random.word(),
         pkey: faker.random.word(),
         actionExpiration: faker.date.future().toISOString(),
         type: faker.random.arrayElement( ItemTypes.slice( 1 )),
         activity: faker.random.arrayElement( ItemActivities.slice( 1 )),
         actions: ItemActions,
         isLast: false,
      });
   }
}
